import { render, staticRenderFns } from "./editcustomer2.vue?vue&type=template&id=43b003dd&scoped=true"
import script from "./editcustomer2.vue?vue&type=script&lang=js"
export * from "./editcustomer2.vue?vue&type=script&lang=js"
import style0 from "./editcustomer2.vue?vue&type=style&index=0&id=43b003dd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b003dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43b003dd')) {
      api.createRecord('43b003dd', component.options)
    } else {
      api.reload('43b003dd', component.options)
    }
    module.hot.accept("./editcustomer2.vue?vue&type=template&id=43b003dd&scoped=true", function () {
      api.rerender('43b003dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customer/editcustomer2.vue"
export default component.exports